import { api } from "../services/axios";

const SearchFileAPI = async (id: string, pathMain: string, page: number = 1, take: number = 7, word: string = "", folderId: string | undefined) => {
    try {
        const result = await api.get(`/internalProjectsFile/GetByPath/${id}`, {
            params: {
                page: page,
                take: take,
                word: word != "" ? word : "all",
                parentFolder: folderId != undefined ? folderId : null,
                path: pathMain,
                IsSearch: true
            }
        });
        return result.data;

    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DownloadFileAPI = async (id: string, internalProjectsId: string | undefined) => {
    try {
        const result = await api.post(`/internalProjectsFile/Download/${internalProjectsId}/${id}`, {}, {
            responseType: 'blob'
        });
        const contentDisposition = result.headers['content-disposition'];
        const contentType = result.headers['content-type'];

        let fileName = 'download-file';
        if (contentDisposition) {
            let match = contentDisposition.match(/filename="(.+?)"/);
            if (!match) match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (match && match[1]) fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
        }

        var blob = new Blob([result.data], { type: contentType });

        const fileURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        URL.revokeObjectURL(fileURL);
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    SearchFileAPI,
    DownloadFileAPI
}